import React from 'react';
import { CssBaseline, makeStyles } from '@material-ui/core';
import { ChangePasswordModal, Header, MainSidebar, Snackbar } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import {
  isLoggedInSelector,
  currentUserSelector,
  visibleChangePasswordSelector,
  isChangingPasswordSelector,
  finishedChangePasswordSelector,
  errorChangePasswordSelector
} from 'common/redux/global/selectors';
import * as GlobalActions from 'common/redux/global/actions';
import { useRouter } from 'common/utils/hooks';
import routes from 'common/router/routes';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    minHeight: '100vh',
    background: 'transparent'
  },
  mainContent: {
    flex: 1,
    overflow: 'hidden',
    background: 'transparent'
  },
  headerSeparator: {
    height: '50px'
  }
});
export interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { query } = useRouter();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const currentUser = useSelector(currentUserSelector);
  const visibleChangePassword = useSelector(visibleChangePasswordSelector);
  const isChangingPassword = useSelector(isChangingPasswordSelector);
  const finishedChangePassword = useSelector(finishedChangePasswordSelector);
  const errorChangePassword = useSelector(errorChangePasswordSelector);

  const manageSession = () => {
    // @ts-ignore
    dispatch(GlobalActions.manageSession({ token: query.token }));
  };


  React.useLayoutEffect(() => {
    manageSession();    
  }, []);

  if (!currentUser || !isLoggedIn) {
    return null;
  }

  const onCloseChangePasswordModal = () => {
    dispatch(GlobalActions.toggleChangePasswordModal());
    setTimeout(() => dispatch(GlobalActions.resetChangePasswordModal()), 1000);
  };

  const changePasswordRequest = (request: any) =>
    // @ts-ignore
    dispatch(GlobalActions.changeUserPasswordRequest(request));

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header />
      <MainSidebar routes={routes} />
      <main className={classes.mainContent}>
        <div className={classes.headerSeparator} />
        {children}
        <Snackbar />
      </main>
      <ChangePasswordModal
        visible={visibleChangePassword}
        onClose={onCloseChangePasswordModal}
        onConfirm={changePasswordRequest}
        loading={isChangingPassword}
        finished={finishedChangePassword}
        error={errorChangePassword}
      />
    </div>
  );
}
